import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { WatchlistExt } from "src/types/watchlists";
import { serializeError } from "../storeUtils";

interface StateType {
  watchlistsPending: boolean;
  watchlists: WatchlistExt[] | null;
  error: string;
}

const initialState: StateType = {
  watchlistsPending: false,
  watchlists: null,
  error: "",
};

const WatchlistsSlice = createSlice({
  name: "Watchlists",
  initialState,
  reducers: {
    hasError(state: StateType, action) {
      state.error = serializeError(action.payload);
      state.watchlistsPending = false;
    },
    getWatchlistsPending: (state) => {
      state.watchlistsPending = true;
    },
    getWatchlistsResult: (
      state,
      action: PayloadAction<{ items: WatchlistExt[] }>,
    ) => {
      state.watchlists = action.payload.items;
      state.watchlistsPending = false;
    },
  },
});

export const { getWatchlistsPending, getWatchlistsResult, hasError } =
  WatchlistsSlice.actions;

export default WatchlistsSlice.reducer;
